import { Configuration, PopupRequest } from "@azure/msal-browser";

export const parseEnabledFlag = (value: string | undefined): boolean =>
    value?.trim().toLowerCase() === "true";

export const isMedicalRecordsEnabled = (): boolean =>
    parseEnabledFlag(process.env.REACT_APP_MEDICAL_RECORDS_ENABLED);

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID || "f1595911-a691-4a09-b02a-e4d9be4fc641",
        authority: process.env.REACT_APP_AZURE_AUTHORITY || "https://login.microsoftonline.com/49423d5d-8d49-4128-b53d-59537808f6ac",
        redirectUri: "/",
        postLogoutRedirectUri: "/"
    },
    system: {
        allowNativeBroker: false // Disables WAM Broker
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["User.Read", "User.Read.All"]
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
